import React, {useEffect, useState} from 'react';

import {BrowserRouter, HashRouter} from "react-router";
import AppRouter from "./router/AppRouter";
import {SnackbarProvider} from "notistack";

import { AllCommunityModule, ModuleRegistry } from 'ag-charts-community';
import Typography from "@mui/material/Typography";

export default function AppLoader(){

    const [isLoaded, setLoaded] = useState(false);

    useEffect(() => {

        ModuleRegistry.registerModules([AllCommunityModule]);
        setLoaded(true);

    }, []);

    //TODO: detect if build for mobile as app
    const isMobile = false;

    if(isMobile){

        return (
            <SnackbarProvider>
                <HashRouter>
                    <AppRouter />
                </HashRouter>
            </SnackbarProvider>
        )

    }


    if(isLoaded) {
        return (
            <SnackbarProvider>
                <BrowserRouter>
                    <AppRouter/>
                </BrowserRouter>
            </SnackbarProvider>
        )
    }

    return <><Typography>Loading...</Typography></>
}
// export default App;
